var map = {
	"./dice-logo1.svg": "e405",
	"./dice-logo2.svg": "4e84",
	"./dice-logo3.svg": "8fcb",
	"./dice1.svg": "1ffb",
	"./dice2.svg": "afb3",
	"./dice3.svg": "4aa0",
	"./dice4.svg": "e6e6",
	"./dice5.svg": "804c",
	"./dice6.svg": "124f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba07";